export default __webpack_public_path__ + "static/media/twitter-square-brands.a74d925b.svg";